var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up"},[_c('div',{staticClass:"navigate_wrap"},[_c('div',{staticClass:"line1"},[_c('span',[_vm._v("Copyright ©2025 河南良悦信息科技有限公司版权所有")])]),_c('div',{staticClass:"line2"},[_c('span',[_vm._v("豫ICP备2022018655号-1")])])])])
}]

export { render, staticRenderFns }